var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('user-goals-table',{ref:"usersGoalsTable"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }